import {
  IFtthOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

export function orderStatusInProgress(
  orchestrator: IFtthOrchestrator | IMultiOrderOrchestrator | undefined,
) {
  if (orchestrator && orchestrator.orderStatus) {
    return (
      orchestrator?.orderStatus === "InProgressPayment" ||
      orchestrator?.orderStatus === "InProgressFulfillment" ||
      orchestrator?.orderStatus === "FulfillmentFinishing"
    );
  }
  return;
}
